import Swiper, {Navigation, Pagination, Thumbs} from 'swiper';
import 'swiper/swiper-bundle.min.css'; // Ensure Swiper CSS is included

export default class FoodSwiper {

    constructor(el) {
        this.el = el;

        setTimeout(() => {
            var swiper = new Swiper(el.querySelector('.js-main-food-swiper'), {
                modules: [Navigation],
                navigation: {
                    nextEl: this.el.querySelector('.js-swiper-food-button-next'),
                    prevEl: this.el.querySelector('.js-swiper-food-button-prev'),
                    disabledClass: "is-disabled"

                },
                loop: false,
                slidesPerView: "auto",
                spaceBetween: 16,
                breakpoints: {
                    640: {
                        slidesPerView: 2,
                        spaceBetween: 10,
                    },
                    768: {
                        slidesPerView: 3,
                        spaceBetween: 20,
                    },
                    1200: {
                        slidesPerView: 4,
                        spaceBetween: 16,
                    },
                },
            });
        }, 500);
    }
}
